const strings = {
  specific_bid: 'Flexi Bid',
  cut_off_bid: 'Cut Off Bid',
  amenities: [
    'swimming_pool',
    'club_house',
    'children_play_area',
    'basket_ball_practice_pitch',
    'tennis_court',
    'badminton_court',
    'football_ground',
    'gymnasium',
    'jogging_track',
    'indoor_games',
    'video_security',
    'amphitheatre',
    'art_and_craft_studio',
    'indoor_squash_court',
    'barbeque_pit',
    'coffee_lounge',
    'dance_studio',
    'cycle_track',
    'spa',
    'lobby_garden',
    'home_automation',
    'super_market',
    'rcc_sumps_sewage_and_overhead_tank',
    'security_room',
    'intercom',
    'pharmacy',
    'power_back_up',
    'land_scape_area',
    'day_care_centre',
    'meditation_centre',
    'cricket_practice_pitch',
    'organic_farm',
    'air_purifier',
    'skating__court',
    'senior_citizen_sitting_area',
    'golf_course',
    'passenger_and_service_lift',
    'access_ramp_for_physicaly_challenged',
    'steam_room',
    'sauna_room',
    'massage_room',
    'mini_theatre',
    'digital_gaming_zone',
    'table_tennis',
    'atm',
    'laundry_and_dry_cleaners',
    'library',
    'outdoor_exercise_area_with_equipments',
    'common_toilet__for_servant_and_drivers',
    'pick_up_and_drop_off_point',
    'car_parking',
    'park',
    'volley_ball',
    'multipurpose_court',
    'half_basket_ball_court',
    'beach_volley_ball',
    'kids_play_area',
    'outdoor_socializing_space',
    'yoga_deck',
    'toddlers_pool',
    'banquet_lawn',
    'pantry',
  ],
  takeAQuizAmenities: [
    'gas_pipeline',
    'gymnasium',
    'swimming_pool',
    'passenger_and_service_lift',
    'car_parking',
    'power_back_up',
    'park',
  ],
  unitTypes: [
    { id: 'APARTMENT', name: 'Apartment' },
    { id: 'INDEPENDENT_HOUSE', name: 'Independent House' },
    { id: 'INDEPENDENT_FLOOR', name: 'Independent Floor' },
    { id: 'STUDIO', name: 'Studio' },
    { id: 'DUPLEX', name: 'Duplex' },
    { id: 'PENTHOUSE', name: 'Penthouse' },
    { id: 'ROW_HOUSE', name: 'Row House' },
  ],

};

export default strings;



// WEBPACK FOOTER //
// ./src/constants/strings.js